// extracted by mini-css-extract-plugin
module.exports = {"app":"_2gQx0RnM636bVIKcs9yOT8","overlay":"_3lQ-4X8mz527RBLCjeSUwW"};